module.exports = __webpack_public_path__ + "media/music/jazzy_bass_3-6ed577be.mp3";